import script from "./HomeFacultyReport.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeFacultyReport.vue?vue&type=script&setup=true&lang=js"

import "./HomeFacultyReport.vue?vue&type=style&index=0&id=4dcb8d8c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dcb8d8c"]])

export default __exports__